import { Button } from "@src/appV2/redesign/components/Button";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

interface ExtendShiftActionProps {
  onExtendShift: () => void;
}

export function ExtendShiftAction(props: ExtendShiftActionProps) {
  const { onExtendShift } = props;

  return (
    <Button
      variant="outlined"
      size={isRebrandingEnabled() ? "large" : undefined}
      startIconType="clock"
      onClick={onExtendShift}
    >
      Extend shift
    </Button>
  );
}
